import { render, staticRenderFns } from "./EnvironmentPage.vue?vue&type=template&id=077d1fea"
import script from "./EnvironmentPage.vue?vue&type=script&lang=js"
export * from "./EnvironmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports